module.exports = __webpack_public_path__ + "static/media/media_left_arrow.b7202e7b.svg";